import React from "react";
import { Box, Card, Typography, Container, Avatar } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const InterviewCompletion = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="sm">
        <Card
          elevation={0}
          sx={{
            p: 5,
            borderRadius: 3,
          }}
        >
          {/* Success Icon */}
          <Box display="flex" justifyContent="center" mb={3}>
            <Avatar
              sx={{
                width: 64,
                height: 64,
                backgroundColor: "#d4f4dd",
              }}
            >
              <CheckCircleIcon sx={{ fontSize: 40, color: "#10b981" }} />
            </Avatar>
          </Box>

          {/* Title */}
          <Typography
            variant="h6"
            align="center"
            gutterBottom
            sx={{ fontWeight: 600, color: "#1a1a1a", mb: 2 }}
          >
            Interview Submitted Successfully!
          </Typography>

          {/* Description */}
          <Typography
            variant="body2"
            align="center"
            color="text.secondary"
            sx={{ mb: 4, lineHeight: 1.6 }}
          >
            Thank you for completing your interview with IGNA Scout. Your
            responses have been recorded and will be reviewed by our Talent Acquisition
            Team.
          </Typography>

          {/* What Happens Next Section */}
          <Box
            sx={{
              backgroundColor: "#eff6ff",
              borderRadius: 2,
              p: 3,
              mb: 3,
              border: "1px solid #bbdefb",
            }}
          >
            <Typography
              variant="subtitle1"
              align="center"
              sx={{ fontWeight: 600, mb: 2.5, color: "#1a1a1a" }}
            >
              What Happens Next?
            </Typography>

            {/* Step 1 */}
            <Box display="flex" gap={2} mb={2.5}>
              <Box
                sx={{
                  minWidth: 28,
                  height: 28,
                  borderRadius: "50%",
                  backgroundColor: "#dbeafe",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  color: "#2563eb",
                }}
              >
                1
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#1a1a1a", mb: 0.5 }}
                >
                  AI Analysis
                </Typography>
                <Typography variant="body2" color="text.secondary">
                Your interview is currently being analyzed to generate behavioral and response scores.
                </Typography>
              </Box>
            </Box>

            {/* Step 2 */}
            <Box display="flex" gap={2} mb={2.5}>
              <Box
                sx={{
                  minWidth: 28,
                  height: 28,
                  borderRadius: "50%",
                  backgroundColor: "#dbeafe",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  color: "#2563eb",
                }}
              >
                2
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#1a1a1a", mb: 0.5 }}
                >
                  HR Review
                </Typography>
                <Typography variant="body2" color="text.secondary">
                Our Talent Acquisition Team will review your recording together with the assessment scores.
                </Typography>
              </Box>
            </Box>

            {/* Step 3 */}
            <Box display="flex" gap={2}>
              <Box
                sx={{
                  minWidth: 28,
                  height: 28,
                  borderRadius: "50%",
                  backgroundColor: "#dbeafe",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  color: "#2563eb",
                }}
              >
                3
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#1a1a1a", mb: 0.5 }}
                >
                  Decision
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  You will be contacted via email regarding the next steps in
                  your application process.
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Interview ID Section */}
          {/* <Box
            sx={{
              backgroundColor: "#f0fdf4",
              borderRadius: 2,
              p: 2.5,
              mb: 3,
              textAlign: "center",
              border: "1px solid #bbf7d0",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: "#1a1a1a",
                mb: 0.5,
                color: "#047857",
              }}
            >
              Interview ID:{" "}
              <Box component="span" sx={{ fontWeight: 400, color: "#059669" }}>
                INT-2024-4582
              </Box>
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "#059669", fontWeight: 500 }}
            >
              Please save this ID for your records
            </Typography>
          </Box> */}

          {/* Footer */}
          <Typography variant="body2" color="text.secondary" align="center">
            You may now safely close this window
          </Typography>
        </Card>
      </Container>
    </Box>
  );
};

export default InterviewCompletion;
